export const roleTableKeys = [
  {
    name: "Role Name",
    key: "name",
  },
];
